import React, { useState } from 'react';
import { track } from '@utils';

function useDrawerState({
  initialState = false,
  trackKey = null,
  setInterval = (interval) => null,
  setInsightsFilter = (filter) => null,
}) {
  const [visible, setVisible] = useState(initialState);
  const openDrawer = () => {
    setVisible(true);

    // tracking event
    if (trackKey) {
      track({ event: trackKey });
    }
  };
  const closeDrawer = () => setVisible(false);

  return { visible, openDrawer, closeDrawer, setInterval, setInsightsFilter };
}

export default useDrawerState;
